import {sendGtagEvent} from "./gtagFunc.ts";
import debounce from "lodash/debounce";

export class GAEvents {

    // Word Maker Result点击next
    public static wordMakerResultNextClick = debounce(() => {
        sendGtagEvent('next_click', {
            event_category: 'Word Maker Result',
            event_label: ''
        })
    }, 100)

    // Word Maker Result点击like
    public static wordMakerResultLikeClick = debounce(() => {
        sendGtagEvent('like_click', {
            event_category: 'Word Maker Result',
            event_label: ''
        })
    }, 100)

    // Word Maker Result 曝光
    public static wordMakerResultShow = debounce(() => {
        sendGtagEvent('impression', {
            event_category: 'Word Maker Result',
            event_label: ''
        })
    }, 100)

    // Word Maker Play游戏界面曝光
    public static wordMakerPlayGameShow = debounce(() => {
        sendGtagEvent('impression', {
            event_category: 'Word Maker Play',
            event_label: ''
        })
    }, 100)

    // My Puzzles上模式点击创建
    public static myPuzzleModeCreateClick = debounce(() => {
        sendGtagEvent('create_click', {
            event_category: 'My Puzzles',
            event_label: ''
        })
    }, 100)

    // My Puzzles上模式点击切换按钮
    public static myPuzzleModeClick = debounce((mode: string) => {
        sendGtagEvent('mode_click', {
            event_category: 'My Puzzles',
            event_label: mode
        })
    }, 100)

    // My Puzzles展示曝光
    public static myPuzzleShow = debounce(() => {
        sendGtagEvent('impression', {
            event_category: 'My Puzzles',
            event_label: ''
        })
    }, 100)

    // Word Maker点击卡片
    public static wordMakerClick = debounce((mode: string) => {
        sendGtagEvent('mode_click', {
            event_category: 'Word Maker',
            event_label: mode
        })
    }, 100)

    // Word Maker展示曝光
    public static wordMakerShow = debounce(() => {
        sendGtagEvent('impression', {
            event_category: 'Word Maker',
            event_label: ''
        })
    }, 100)

    // My Matches点击enter the match按钮
    public static myMatchesClickEnter = debounce(() => {
        sendGtagEvent('join_click', {
            event_category: 'My Matches',
            event_label: ''
        })
    }, 100)

    // My Matches展示曝光
    public static myMatchesShow = debounce(() => {
        sendGtagEvent('impression', {
            event_category: 'My Matches',
            event_label: ''
        })
    }, 100)

    // Join Match页面点击join
    public static joinMatchClick = debounce(() => {
        sendGtagEvent('join_click', {
            event_category: 'Join Match',
            event_label: ''
        })
    }, 100)

    // Join Match 展示曝光
    public static joinMatchShow = debounce(() => {
        sendGtagEvent('impression', {
            event_category: 'Join Match',
            event_label: ''
        })
    }, 100)

    // Create Match Result弹窗曝光
    public static createMatchResult = debounce(() => {
        sendGtagEvent('impression', {
            event_category: 'Create Match Result',
            event_label: ''
        })
    }, 100)

    // Create Match PK Play游戏页面曝光
    public static createMatchPlay = debounce(() => {
        sendGtagEvent('impression', {
            event_category: 'Create Match PK Play',
            event_label: ''
        })
    }, 100)

    // Create Match PK 页面点击 cancel
    public static createMatchCancel = debounce(() => {
        sendGtagEvent('cancel_click', {
            event_category: 'Create Match PK',
            event_label: ''
        })
    }, 100)

    // Create Match PK 曝光
    public static createMatchShowInPkPage = debounce(() => {
        sendGtagEvent('impression', {
            event_category: 'Create Match PK',
            event_label: ''
        })
    }, 100)

    // Create Match Invite 页面曝光
    public static createMatchShowInWaitingPage = debounce(() => {
        sendGtagEvent('impression', {
            event_category: 'Create Match Invite',
            event_label: ''
        })
    }, 100)

    // Create Match Invite中点击分享
    public static createMatchInviteClickShare = debounce(() => {
        sendGtagEvent('share_click', {
            event_category: 'Create Match Invite',
            event_label: ''
        })
    }, 100)

    // Create Match Link页面点击invite
    public static createMatchLinkClickInvite = debounce(() => {
        sendGtagEvent('invite_click', {
            event_category: 'Create Match Start',
            event_label: ''
        })
    }, 100)

    // Create Match Link页面点击start
    public static createMatchLinkClickStart = debounce(() => {
        sendGtagEvent('start_click', {
            event_category: 'Create Match Start',
            event_label: ''
        })
    }, 100)


    // Create Match Start页面曝光
    public static createMatchStart = debounce(() => {
        sendGtagEvent('impression', {
            event_category: 'Create Match Start',
            event_label: ''
        })
    }, 100)

    // Create Match Link分享页面点击start_match
    public static createMatchLinkStart = debounce(() => {
        sendGtagEvent('start_match_click', {
            event_category: 'Create Match Link',
            event_label: ''
        })
    }, 100)

    // Create Match Link分享页面点击share
    public static createMatchLinkShare = debounce(() => {
        sendGtagEvent('share_click', {
            event_category: 'Create Match Invite',
            event_label: ''
        })
    }, 100)

    // Create Match Link展示曝光
    public static createMatchLinkShow = debounce(() => {
        sendGtagEvent('impression', {
            event_category: 'Create Match Link',
            event_label: ''
        })
    }, 100)

    // Create Match展示曝光
    public static createMatchShow = debounce(() => {
        sendGtagEvent('impression', {
            event_category: 'Create Match',
            event_label: ''
        })
    }, 100)

    // Create Match选择难度
    public static vsPlayerSelectDifficulty = debounce((difficulty: string) => {
        sendGtagEvent('mode_click', {
            event_category: 'Create Match',
            event_label: difficulty
        })
    }, 100)

    // Create Match展示曝光
    public static createMatchPageShow = debounce(() => {
        sendGtagEvent('impression', {
            event_category: 'Create Match',
            event_label: ''
        })
    }, 100)

    // VS Player页面点击各个选项
    public static vsPlayerPageClickCard(mode: string) {
        sendGtagEvent('mode_click', {
            event_category: 'VS Player',
            event_label: mode
        })
    }

    // VS Player页面展示曝光
    public static vsPlayerPageShow = debounce(() => {
        sendGtagEvent('impression', {
            event_category: 'VS Player',
            event_label: ''
        })
    }, 100)

    // 下载弹窗点击下载按钮
    public static downloadPopupClickDownloadButton = debounce((type: string) => {
        sendGtagEvent('down_click', {
            event_category: 'Download_Pop',
            event_label: type
        })
    }, 100)

    // 下载弹窗展示曝光
    public static downloadPopupShow = debounce(() => {

        sendGtagEvent('impression', {
            event_category: 'Download_Pop',
            event_label: "",
        })
    }, 100)

    // Leaderboard 页面没有数据时点击refresh按钮事件
    public static leaderboardPageChallengeRefresh = debounce(() => {
        sendGtagEvent('refresh_click', {
            event_category: 'Leaderboard',
            event_label: "",
        })
    }, 100)


    // Leaderboard 页面展示曝光
    public static leaderboardPageShow = debounce((page: string) => {
        sendGtagEvent('impression', {
            event_category: page,
            event_label: "",
        })
    }, 100)

    // AI Challenge Game 挑战失败弹窗点击challenge按钮
    public static aiChallengeGameFailPopupChallengeClick = debounce(() => {
        sendGtagEvent('challenge_click', {
            event_category: 'Try Again',
            event_label: "",
        })
    }, 100)

    // AI Challenge Game 挑战失败弹窗点击share按钮
    public static aiChallengeGameFailPopupShareClick = debounce(() => {
        sendGtagEvent('share_click', {
            event_category: 'Try Again',
            event_label: "",
        })
    }, 100)

    // AI Challenge Game 挑战失败弹窗展示曝光
    public static aiChallengeGameFailPopupShow = debounce(() => {
        sendGtagEvent('impression', {
            event_category: 'Try Again',
            event_label: "",
        })
    }, 100)

    // AI Challenge Game Next Level按钮点击事件
    public static aiChallengeGameNextLevelClick = debounce(() => {
        sendGtagEvent('next_level_click', {
            event_category: 'Challenge_Play_Win',
            event_label: "",
        })
    }, 100)

    // AI Challenge Game 页面点击分享按钮
    public static aiChallengeGameShareClick = debounce(() => {
        sendGtagEvent(
            'share_click', {
                event_category: 'Challenge_Play_Win',
                event_label: "",
            })
    }, 100)

    // AI Challenge Game 挑战成功页面曝光
    public static aiChallengeGameSuccessShow = debounce(() => {
        sendGtagEvent('impression', {
            event_category: 'Challenge_Play_Win',
            event_label: "",
        })
    }, 100)

    // AI Challenge Game 点击退出按钮
    public static aiChallengeGameExitButtonClick = debounce(() => {
        sendGtagEvent('exit_click', {
            event_category: 'Challenge_Play',
            event_label: "",
        })
    }, 100)

    // AI Challenge Game 点击帮助按钮
    public static aiChallengeGameHelpTip = debounce(() => {
        sendGtagEvent('how_to_play_click', {
            event_category: 'Challenge_Play',
            event_label: "",
        })
    }, 100)

    // AI Challenge Game点击设置按钮
    public static aiChallengeGameSetting = debounce(() => {
        sendGtagEvent('set_click', {
            event_category: 'Challenge_Play',
            event_label: "",
        })
    }, 100)

    // AI Challenge Game页面展示曝光
    public static aiChallengeGamePageShow = debounce(() => {
        sendGtagEvent('impression', {
            event_category: 'Challenge_Play',
            event_label: "",
        })
    }, 100)

    // AI Challenge页面点击取消按钮
    public static aiChallengeCancelButtonClick = debounce(() => {
        sendGtagEvent('cancel_click', {
            event_category: 'Challenge',
            event_label: "",
        })
    }, 100)

    // AI challenge主页展示曝光
    public static aiChallengePageShow = debounce(() => {
        sendGtagEvent('impression', {
            event_category: 'Challenge',
            event_label: "",
        })
    }, 100)

    // 每日游戏结束弹窗点击AI challenge按钮事件
    public static dailyGameEndDialogAIClick = debounce((result: string) => {
        sendGtagEvent('challenge_click', {
            event_category: 'Play_Pop',
            event_label: result,
        })
    }, 100)

    // 每日游戏结束弹窗新闻链接点击事件
    public static dailyGameEndDialogNewsClick = debounce((result: string, newsId: string, newsTitle: string) => {
        sendGtagEvent('news_click', {
            event_category: 'Play_Pop',
            event_label: result,
            news_id: newsId,
            news_headline: newsTitle,
        })
    }, 100)

    // 每日游戏结束弹窗分享按钮点击
    public static dailyGameEndDialogShareClick = debounce((result: string) => {
        sendGtagEvent('share_click', {
            event_category: 'Play_Pop',
            event_label: result,
        })
    }, 100)

    // 用户在完成每日模式后弹出的结果弹窗 曝光
    public static dailyGameEndDialogShow = debounce((result: string) => {
        sendGtagEvent('impression', {
            event_category: 'Play_Pop',
            event_label: result,
        })
    }, 100)

    // 每日游戏结束后点击challenge按钮
    public static dailyGameChallengeButtonClick = debounce((result: string) => {
        sendGtagEvent('challenge_click', {
            event_category: 'Play',
            event_label: result,
        })
    }, 100)

    // 每日游戏模式游戏结果
    public static dailyGameResult = debounce((result: string) => {
        sendGtagEvent('impression', {
            event_category: 'Play',
            event_label: result,
        })
    }, 100)

    // hint弹窗上点击取消按钮
    public static hintDialogCancel = debounce(() => {
        sendGtagEvent('cancel_click', {
            event_category: 'Play_01_Tip',
            event_label: "",
        })
    }, 100)

    // hint弹窗上点击confirm按钮
    public static hintDialogConfirm = debounce(() => {
        sendGtagEvent('confirm_click', {
            event_category: 'Play_01_Tip',
            event_label: "",
        })
    }, 100)

    // hint确认弹窗的显示曝光
    public static hintDialogSHow = debounce(() => {
        sendGtagEvent('impression', {
            event_category: 'Play_01_Tip',
            event_label: "",
        })
    }, 100)

    // 每日游戏界面hint提示按钮点击
    public static dailyGameHintClick = debounce(() => {
        sendGtagEvent('hint_click', {
            event_category: 'Play_01',
            event_label: "",
        })
    }, 100)

    // 每日游戏界面点击左上角退出按钮
    public static dailyGameExitClick = debounce(() => {
        sendGtagEvent('exit_click', {
            event_category: 'Play_01',
            event_label: "",
        })
    }, 100)

    // 每日页面游戏帮助弹窗点击
    public static dailyGameHelpClick = debounce(() => {
        sendGtagEvent('how_to_play_click', {
            event_category: 'Play_01',
            event_label: "",
        })
    }, 100)

    // 每日游戏界面点击设置按钮
    public static dailyGameSettingClick = debounce(() => {
        sendGtagEvent('set_click', {
            event_category: 'Play_01',
            event_label: "",
        })
    }, 100)

    // 每日游戏页面展示曝光
    public static dailyGameShow = debounce(() => {
        sendGtagEvent('impression', {
            event_category: 'Play_01',
            event_label: "",
        })
    }, 100)

    // 进入每日游戏后自动弹出的how to play
    public static howToPlayAutoShow = debounce(() => {
        sendGtagEvent('impression', {
            event_category: 'How To Play_01',
            event_label: "",
        })
    }, 100)

    // 设置按钮点击
    public static settingButtonClick = debounce((button: string) => {
        sendGtagEvent('set_click', {
            event_category: 'Settings',
            event_label: button,
        })
    }, 100)

    // Avatar展示曝光
    public static avatarShow = debounce(() => {
        sendGtagEvent('impression', {
            event_category: 'Avatar Profile',
            event_label: "",
        })
    }, 100)

    // Skins展示曝光
    public static skinsShow = debounce(() => {
        sendGtagEvent('impression', {
            event_category: 'Skins Profile',
            event_label: "",
        })
    }, 100)

    // Achievements展示曝光
    public static achieveShow = debounce(() => {
        sendGtagEvent('impression', {
            event_category: 'Achievements',
            event_label: "",
        })
    }, 100)

    // profile里点击achieve
    public static profileAchieveClick = debounce(() => {
        sendGtagEvent('achieve_click', {
            event_category: 'Your Profile',
            event_label: "",
        })
    }, 100)

    // profile里点击skin
    public static profileSkinClick = debounce(() => {
        sendGtagEvent('skin_click', {
            event_category: 'Your Profile',
            event_label: "",
        })
    }, 100)

    // profile点击info
    public static profileInfoClick = debounce(() => {
        sendGtagEvent('info_click', {
            event_category: 'Your Profile',
            event_label: "",
        })
    }, 100)

    // profile里点击country/region按钮
    public static profileCountryClick = debounce(() => {
        sendGtagEvent('region_click', {
            event_category: 'Your Profile',
            event_label: "",
        })
    }, 100)

    // 设置页面展示曝光
    public static settingShow = debounce(() => {
        sendGtagEvent('impression', {
            event_category: 'Settings',
            event_label: "",
        })
    }, 100)

    // 个人主页展示曝光
    public static profileShow = debounce(() => {
        sendGtagEvent('impression', {
            event_category: 'Your Profile',
            event_label: "",
        })
    }, 100)

    // 主页点击设置按钮
    public static homePageSettingButtonClick = debounce(() => {
        sendGtagEvent('set_click', {
            event_category: 'Home',
            event_label: "",
        })
    }, 100)

    // 主页点击下载按钮
    public static homePageDownloadButtonClick = debounce(() => {
        sendGtagEvent('download_click', {
            event_category: 'Home',
            event_label: "",
        })
    }, 100)

    // 主页点击profile按钮
    public static homePageProfileClick = debounce(() => {
        sendGtagEvent('profile_click', {
            event_category: 'Home',
            event_label: "",
        })
    }, 100)

    // 主页点击游戏模式
    public static homePageGameModeClick = debounce((gameMode: string) => {
        sendGtagEvent('mode_click', {
            event_category: 'Home',
            event_label: gameMode,
        })
    }, 100)

    // home页面展示曝光
    public static homePageShow = debounce(() => {
        sendGtagEvent('impression', {
            event_category: 'Home',
            event_label: "",
        })
    }, 100)

    // 登录页面展示曝光
    public static loginPageShow = debounce(() => {
        sendGtagEvent('impression', {
            event_category: 'Login',
            event_label: "",
        })
    }, 100)

    // 登录按钮点击事件
    public static loginButtonClick = debounce((button: string) => {
        sendGtagEvent('login_click', {
            event_category: 'Login',
            event_label: button,
        })
    }, 100)

    // 全局展示曝光
    public static globalShow = debounce((page?: string) => {
        sendGtagEvent("user_stay", {
            event_category: 'Global',
            event_label: page ?? "",
        })
    }, 100)

    // 全局设置GA4的platform_type属性
    // public static globalSet() {
    //     // 设置全局的platform_type属性
    //     const isMobile = JudgmentPlatform.isCGTNAPPAutoJudge();
    //     set({
    //         platform_type: isMobile ? "app" : "web",
    //     })
    // }

}